var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false,"showFilter":true,"showSearch":true,"showExportation":true}},[_vm._v("الشركات")]),_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.VUE_APP_TRANSPORTATION_LINK,"status-url":'companies/status',"list_url":'companies'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }